import PartnersArrow_SVG from './PartnersArrowIcon.svg'
import AddUser_SVG from './AddUserIcon.svg'
import Filter_SVG from './filterIcon.svg'
import Download_SVG from './DownloadIcon.svg'
import Plus_SVG from './PlusIcon.svg'
import ViewDetails_SVG from './ViewDetailIcon.svg'
import DeleteUser_SVG from './DeleteUserIcon.svg'
import Print_SVG from './PrintIcon.svg'
import BbpsB_SVG from './bbpsBIcon.svg'
import ComplaintFinish_SVG from './ComplaintFinishIcon.svg'
import NewBBPS_SVG from './NewBBPSIcon.svg'
import Clock_SVG from './clockIcon.svg'
import Note_SVG from './NoteIcon.svg'
import Reports_SVG from './ReportsIcon.svg'
import Compensation_SVG from './CompensationIcon.svg'
import PaymentRequest_SVG from './PaymentRequestIcon.svg'
import Services_SVG from './ServicesIcon.svg'
import Settings_SVG from './SettingsIcon.svg'
import Notifications_SVG from './NotificationsIcon.svg'
import SearchnormalSVG from './Searchnormal.svg'
import BMnemonicSVG from './BMnemonicSVG.svg'
import BAssuredSVG from './BAssuredSVG.svg'

export const PartnerArrowIcon = (hg, wd) => {
    return <img src={PartnersArrow_SVG} alt='PartnersArrow_SVG' style={{height:'10px'}}/>
}

export const BmnemonicIcon = (hg, wd) => {
    return <img src={BMnemonicSVG} alt='BMnemonicSVG' style={{height:'30px'}}/>
}
export const BAssuredIcon = (hg, wd) => {
    return <img src={BAssuredSVG} alt='BAssuredSVG' style={{height:'80px'}}/>
}

export const SearchnormalIcon = (hg, wd) => {
    return <img src={SearchnormalSVG} alt='SearchnormalIcon' style={{height:'18px'}}/>
}
export const ReportsIcon = (hg, wd) => {
    return <img src={Reports_SVG} alt='Reports_SVG' style={{height:'28px'}}/>
}
export const SettingsIcon = (hg, wd) => {
    return <img src={Settings_SVG} alt='Reports_SVG' style={{height:'32px'}}/>
}
export const NotificationsIcon = (hg, wd) => {
    return <img src={Notifications_SVG} alt='Reports_SVG' style={{height:'32px'}}/>
}
export const CompensationIcon = (hg, wd) => {
    return <img src={Compensation_SVG} alt='Compensation_SVG' style={{height:'26px'}}/>
}
export const PaymentRequestIcon = (hg, wd) => {
    return <img src={PaymentRequest_SVG} alt='PaymentRequest_SVG' style={{height:'26px'}}/>
}
export const ServicesIcon = (hg, wd) => {
    return <img src={Services_SVG} alt='Services_SVG' style={{height:'22px'}}/>
}

export const NoteIcon = (hg, wd) => {
    return <img src={Note_SVG} alt='Note_SVG' style={{height:'16px'}}/>
}

export const ClockIcon = (hg, wd) => {
    return <img src={Clock_SVG} alt='Clock_SVG' style={{height:'16px'}}/>
}
export const AddUserIcon = (hg, wd) => {
    return <img src={AddUser_SVG} alt='AddUser_SVG' style={{height:'25px'}}/>
}
export const FilterIcon = (hg, wd) => {
    return <img src={Filter_SVG} alt='Filter_SVG' style={{height:'30px'}}/>
}
export const DownloadIcon = (hg, wd) => {
    return <img src={Download_SVG} alt='Download_SVG' style={{height:'20px'}}/>
}
export const PlusIcon = (hg, wd) => {
    return <img src={Plus_SVG} alt='Plus_SVG' style={{height:'18px'}}/>
}
export const ViewDetailsIcon = (hg, wd) => {
    return <img src={ViewDetails_SVG} alt='ViewDetails_SVG' style={{height:'20px'}}/>
}
export const DeleteUserIcon = (hg, wd) => {
    return <img src={DeleteUser_SVG} alt='DeleteUser_SVG' style={{height:'20px'}}/>
}
export const PrintIcon = (hg, wd) => {
    return <img src={Print_SVG} alt='Print_SVG' style={{height:'25px'}}/>
}
export const BbpsBIcon = (hg, wd) => {
    return <img src={BbpsB_SVG} alt='BBpsB_SVG' style={{height:'70px'}}/>
}
export const ComplaintFinishIcon = (hg, wd) => {
    return <img src={ComplaintFinish_SVG} alt='ComplaintFinish_SVG' style={{height:'50px'}}/>
}
export const NewBBPSIcon = (hg, wd) => {
    return <img src={NewBBPS_SVG} alt='NewBBPS_SVG' style={{height:'40px'}}/>
}
